<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

 <template>
    <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
            
        <div class="current-status-graph h-100" style="flex:3; position: relative;" :style="isFlexible ? 'padding: 20px 0;' : 'padding: 0;'">
            <apexchart v-if="series && !thereIsNoData" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series"/>
        </div>

        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column h-100" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ChartTable from "./ChartTable.vue";

export default {
    name: 'CurrentStatusGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts,
        ChartTable
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        
        this.currentChatterData = this.dashboardData.currentChatter;
        
        if(this.currentChatterData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                if(this.isFlexible) {
                    
                    this.series = [];
                    this.chartOptions.labels = [];
                    this.reloadGraph();
                }
            }
        },
    },
    data() {
        return {
            closedCount: 0,
            thereIsNoData:false,
            loading : false,
            label : ['Overdue', 'On Time', 'Done+', 'TBD'],
            currentChatterData : '',
            columnNames: [],
            snapshotData :[],
            series: [],
            chartOptions: {
                chart: {
                    // height:'80%',
                    type: "donut",
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                            show: this.isFlexible,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: true,
                                selection: true,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: true,
                                reset: true | '<img src="/static/icons/reset.png" width="20">',
                                customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                colors: ['#FF6767', '#176BA0', '#19AADE', '#1AC9E6'],

                // 23-09-25 bar => donut 차트 변경
                // plotOptions: {
                //     bar: { 
                //         columnWidth : '100%',
                //         distributed: true,
                //     }
                // },
                // dataLabels: {
                //     enabled: this.isFlexible, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                //     style: {
                //         fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                //         colors: ['#333'], // 데이터 라벨의 색상을 지정합니다.
                //     },
                //     // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                //     offsetY: -9, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                //     formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                //         return val;
                //     },
                //     background: { // 데이터 라벨의 배경을 설정합니다.
                //         enabled: true,
                //         foreColor: '#fff',
                //         padding: 4,
                //         borderRadius: 4,
                //         borderWidth: 1,
                //         borderColor: '#ccc',
                //         opacity: 0.8,
                //     }
                // },
                labels : [],
                dataLabels:{
                    enabled:true,
                    formatter: function(value, { seriesIndex, dataPointIndex, w }) {
                        return w.config.series[seriesIndex];
                    }
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                        donut: {
                            size: '60%',
                            labels: {
                                show: this,
                                value: {
                                    show: true,
                                    color: '#2E2E38',
                                    fontSize: this.isFlexible ? '32px' : '20px',
                                    fontWeight: '700',
                                    offsetY: this.isFlexible ? 10 : 0,
                                    formatter: val => this.formatNumber(val, 0)
                                },
                                total: {
                                    show: true,
                                    label: 'Total',
                                    color: '#747480',
                                    fontSize: this.isFlexible ? '18px' : '14px',
                                    formatter: chart => {
                                        const total = chart.config.series.reduce((a, b) => a + b, 0)
                                        return this.formatNumber(total, 0)
                                    }
                                },
                            },
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    },
                },
                // stroke: {
                //     width: [4, 4, 4, 4],
                //     curve: 'straight',
                // },
                // xaxis: {
                //     categories: [],
                //     show:this.isFlexible,
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                // yaxis: {
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid :{
                    show:false
                }
            },
            tableData: '',
            statusInfo : {
                'TO_DO' : true, 
                'IN_PROGRESS' : true, 
                'DONE' : true, 
                // 'CANCELLED' : false,
                // 'CONFIRMED' : false,
                // 'APPROVED' : false
            }
        }
    },
    methods: {

        countData(dataArray) {
            
            let overdueCount = 0;
            let onTimeCount = 0;
            let completedCount = 0;
            let TBDCount = 0;
            let closedCount = 0;

            // Over Due : TO_DO, IN_PROGRESS 중 DUE_DATE가 지난 항목
            // On Time : TO_DO, IN_PROGERSS 중 DUE_DATE가 지나지 않은 항목
            // Completed : DONE, CANCELLED 된 항목
            // TBD : TO_DO, IN_PROGRESS 중 DUE_DATE가 설정되지 않은 항목
            let todayDate = new Date(this.today);
            dataArray.forEach(data => {
                let dueDate = new Date(data.dueDate);

                switch (data.status) {
                    case 'TO_DO':
                    case 'IN_PROGRESS':
                        if(data.dueDate == '') {
                            TBDCount++;
                        } else if(dueDate < todayDate) {
                            overdueCount++;
                        } else {
                            onTimeCount++;
                        }
                        break;
                    case 'DONE':     
                    case 'CANCELLED':
                        completedCount++;
                        break;
                    case 'CLOSED':
                        closedCount++;
                        break;
                }
            });

            this.closedCount = closedCount;

            // let series = [{
            //     name : '프로그램 개수',
            //     data : [overdueCount, onTimeCount, completedCount, TBDCount]
            // }]

            let series = [overdueCount, onTimeCount, completedCount, TBDCount];

            this.tableData = {                 
                "Status": [
                    "Overdue",
                    "On Time",
                    "Done+",
                    "TBD",
                ],
                "Count": [overdueCount, onTimeCount, completedCount, TBDCount],
            }

            return series;
        },

        visualizeGraph() {
            let dataArray = this.currentChatterData;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {
                    console.log(item);
                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) &&
                        BUSINESS_CATEGORY.includes(item.businessCategory)
                    );
                });
            }
            
            let series = this.countData(dataArray);

            this.series = series;
            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            // this.chartOptions.xaxis.categories = this.label;
            this.chartOptions.labels = this.label;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions({
                    // xaxis: {
                    //     categories: this.label,
                    // },
                    labels:this.label
                });
            }
        },
        setTable() {
            this.tableData = this.data.table;

        },
    },
}
</script>
<style scoped>
.count-label {
    font-size: 2.25rem !important;
    font-weight: 500;
}
.count-data {
    margin-top: 20px;
    font-size: 2.5rem;
    font-weight: 600;
}

.h-80 {
    padding-top: 10px;
    height: 80%;
}
.h-90 {
    height: 90%;
}
</style>
<style>
/* 커스텀 툴팁 스타일 */
.current-status-graph .apexcharts-tooltip {
    border-radius: 100px;
    border: 1px solid #FFF;
    background: transparent;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.20);
}
.current-status-graph .apexcharts-tooltip-series-group.apexcharts-active {
    padding: 0 12px;
}
</style>